import React from "react";
import style from "./index.module.scss";

const Index = ({ title, percent }: { title: string; percent?: number }) => {
    return (
        <div className={style.root}>
            <div className={style.content}>
                <img src={require("./images/icon1.png")} alt="" />
                <b>{title}</b>
                {percent != null && (
                    <>
                        占比&nbsp;&nbsp;
                        <strong className={style.percent}>{percent}%</strong>
                    </>
                )}
            </div>
        </div>
    );
};

export default Index;
